// One fetch per map-payload URL per page load — the masthead constellation and
// the analytical store map draw from the same payload, whichever mounts first.
const cache = new Map()

export function fetchPayload(url) {
  if (!cache.has(url)) {
    cache.set(
      url,
      fetch(url, { headers: { Accept: "application/json" } })
        .then((r) => (r.ok ? r.json() : null))
        .then(decodeDots)
        .catch(() => null)
    )
  }
  return cache.get(url)
}

// Dots ship on the store map's pixel grid (Trends::DotGrid): integer
// Web-Mercator offsets from the bbox's north-west corner at `zoom`, x east,
// y south. Decoded once here into [lon, lat, ci, ni] for both renderers. A
// chain page's dots are all the chain and arrive as bare [x, y] (ci 1, ni 0).
// No zoom = nothing to decode (no bbox, or a cached pre-grid payload that
// still carries lon/lat).
function decodeDots(payload) {
  if (!payload || payload.zoom == null) return payload

  const [west, , , north] = payload.bbox
  const k = (512 * 2 ** payload.zoom) / (2 * Math.PI)
  const x0 = (west * Math.PI) / 180
  const y0 = Math.log(Math.tan(Math.PI / 4 + (north * Math.PI) / 360))
  payload.dots = payload.dots.map(([x, y, ci = 1, ni = 0]) => [
    ((x0 + x / k) * 180) / Math.PI,
    (Math.atan(Math.sinh(y0 - y / k)) * 180) / Math.PI,
    ci,
    ni
  ])
  return payload
}
